import { render, staticRenderFns } from "./PackagesTableForm.vue?vue&type=template&id=063f4869"
import script from "./PackagesTableForm.vue?vue&type=script&lang=js"
export * from "./PackagesTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports